const ROUND = 'fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"';

function arc(radius: number, from: number, to: number): string {
  const point = (angle: number) =>
    `${(12 + radius * Math.cos(angle)).toFixed(2)} ${(12 + radius * Math.sin(angle)).toFixed(2)}`;
  return `M${point(from)}A${String(radius)} ${String(radius)} 0 0 1 ${point(to)}`;
}

export const AVATAR_MARK =
  '<path d="M10 14 3 9.4A8.4 8.4 0 0 1 8.2 5.6Z" fill="currentColor"/>' +
  '<path d="M14 14 21 9.4A8.4 8.4 0 0 0 15.8 5.6Z" fill="currentColor"/>' +
  `<path d="M10 14 5.2 7.2M14 14 18.8 7.2" ${ROUND} stroke-width="1"/>` +
  '<circle cx="12" cy="16.6" r="3.2" fill="currentColor"/>';

export const DECHAINE_ICON =
  [0, 1, 2, 3]
    .map((quarter) => {
      const middle = (quarter * Math.PI) / 2 - Math.PI / 2;
      return `<path d="${arc(9, middle - 0.6, middle + 0.6)}" ${ROUND} stroke-width="${quarter === 0 ? '2.8' : '1.4'}"/>`;
    })
    .join('') +
  '<path d="M12 5.6 13.5 10.5 18.4 12 13.5 13.5 12 18.4 10.5 13.5 5.6 12 10.5 10.5Z" fill="currentColor"/>';
